import React from "react";
import Title from "../../Add/title";
import { Button, IconButton, TextField } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { FaPlus } from "react-icons/fa";

const Contacts = ({
  formData,
  handleChange,
  paymentMethod,
  setPaymentMethod,
  inputValue,
  setInputValue,
}) => {
  const handleAddMethod = () => {
    if (inputValue.trim() !== "") {
      setPaymentMethod([...paymentMethod, inputValue.trim()]);
      setInputValue(""); // Clear the input field after adding
    }
  };

  const handleDeleteMethod = (index) => {
    const updatedMethods = paymentMethod.filter((_, i) => i !== index);
    setPaymentMethod(updatedMethods);
  };

  return (
    <div className="contacts">
      <Title title="Contacts" />
      <div className="contacts-data-container">
        <TextField
          fullWidth
          variant="outlined"
          onChange={(e) => {
            handleChange("smmpanel_email", e.target.value);
          }}
          name="smmpanel_email"
          value={formData?.smmpanel_email}
          label="Panel Email"
          type="email"
          size="small"
        />
        <TextField
          fullWidth
          variant="outlined"
          name="smmpanel_tel1"
          onChange={(e) => {
            handleChange("smmpanel_tel1", e.target.value);
          }}
          value={formData?.smmpanel_tel1}
          label="Phone number"
          size="small"
        />
        <TextField
          fullWidth
          onChange={(e) => {
            handleChange("smmpanel_skybe", e.target.value);
          }}
          variant="outlined"
          name="smmpanel_skybe"
          label="Skype"
          value={formData?.smmpanel_skybe}
          size="small"
        />
        <TextField
          fullWidth
          variant="outlined"
          name="smmpanel_instagram"
          onChange={(e) => {
            handleChange("smmpanel_instagram", e.target.value);
          }}
          label="Instagram"
          value={formData?.smmpanel_instagram}
          size="small"
        />
        <TextField
          fullWidth
          variant="outlined"
          onChange={(e) => {
            handleChange("smmpanel_fb", e.target.value);
          }}
          name="smmpanel_fb"
          value={formData?.smmpanel_fb}
          label="Facebook"
          size="small"
        />
        <TextField
          fullWidth
          variant="outlined"
          name="smmpanel_telegram"
          onChange={(e) => {
            handleChange("smmpanel_telegram", e.target.value);
          }}
          value={formData?.smmpanel_telegram}
          label="Telegram"
          size="small"
        />
        <TextField
          fullWidth
          variant="outlined"
          name="smmpanel_whatsapp"
          onChange={(e) => {
            const value = e.target.value;
            if (/^\+?[0-9]*$/.test(value) && value.length <= 13) {
              handleChange("smmpanel_whatsapp", value);
            }
          }}
          value={formData?.smmpanel_whatsapp || ""}
          label="WhatsApp"
          size="small"
        />

        <TextField
          fullWidth
          variant="outlined"
          name="smmpanel_twitter"
          onChange={(e) => {
            handleChange("smmpanel_twitter", e.target.value);
          }}
          label="Twitter"
          value={formData?.smmpanel_twitter}
          size="small"
        />
      </div>
      <div className="payment-contact">
        <Title title="Payment Methods" />
        <div className="payment-input">
          <TextField
            fullWidth
            variant="outlined"
            name="smmpanel_tel1"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            size="small"
            placeholder="Type your Payment methods"
          />
          <Button
            onClick={handleAddMethod}
            className="add-payment-method !bg-primary"
          >
            <FaPlus color="#fff" size={"1.2rem"} />
          </Button>
        </div>
        <div className="methods">
          {paymentMethod.map((method, index) => (
            <div
              key={index}
              className="method bg-[#d7d7d7] dark:bg-darkSecondary text-darkTextColor dark:text-textColor"
            >
              {method}
              <IconButton
                onClick={() => handleDeleteMethod(index)}
                size="small"
                className="remove-method"
              >
                <CloseIcon sx={{ fontSize: "12px", color: "black" }} />
              </IconButton>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Contacts;
